module.exports = __webpack_public_path__ + "img/s4Model3.e3eccc0b.svg";